import React from 'react';
import { ListItemIcon, MenuItem } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

/** One entry of a role menu; the current choice carries a tick. A forwardRef
 *  component so MUI's Menu can focus it and give it its list role. */
export const RoleMenuItem = React.forwardRef<
  HTMLLIElement,
  { label: string; current: boolean; onClick: () => void }
>(({ label, current, onClick, ...menuProps }, ref) => (
  <MenuItem
    ref={ref}
    {...menuProps}
    onClick={onClick}
    selected={current}
    aria-current={current ? 'true' : undefined}
    sx={{ fontSize: 13, fontWeight: 600 }}
  >
    {label}
    {current && (
      <ListItemIcon sx={{ minWidth: 0, ml: 1 }}>
        <CheckIcon sx={{ fontSize: 16 }} />
      </ListItemIcon>
    )}
  </MenuItem>
));
RoleMenuItem.displayName = 'RoleMenuItem';
